import getKeywordSuggestions from './getKeywordSuggestions';
import getPeopleSuggestions from './getPeopleSuggestions';
import { MAX_SERVER_SUGGESTION_OF_KIND } from '../../constants';
import { getGuid } from 'owa-guid';
import { SearchScenarioId } from 'owa-search-next';
import { lazyGetSearchStore } from 'owa-search-next-lazy';
import { SuggestionSet } from 'owa-search-service';

export default async function getLegacySuggestions(
    scenarioId: SearchScenarioId,
    queryStringForSuggestions: string
): Promise<SuggestionSet> {
    const getSearchStore = await lazyGetSearchStore.import();
    const searchStore = getSearchStore(scenarioId);

    const keywordSuggestions = await getKeywordSuggestions(
        queryStringForSuggestions,
        searchStore.searchSessionGuid,
        MAX_SERVER_SUGGESTION_OF_KIND
    );

    const peopleSuggestions = await getPeopleSuggestions(
        queryStringForSuggestions,
        searchStore.searchSessionGuid,
        MAX_SERVER_SUGGESTION_OF_KIND,
        'gal'
    );

    const suggestions = await Promise.all([keywordSuggestions, peopleSuggestions]).then(
        suggestionSets => {
            // Merge sets of keyword and people suggestions into single set.
            return suggestionSets.reduce((accumulator, suggestionSet) =>
                accumulator.concat(suggestionSet)
            );
        }
    );

    return {
        Suggestions: suggestions,
        TraceId: getGuid(), // Assign a unique ID so we can differentiate between suggestion sets.
        IsComplete: true,
    };
}
